//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageUploader from "../../../../components/ImageUploader";
import SelectCompanyPopup from "./select-company-popup";
import util from "../../../../lib/util";

export default {
    name: "page-result-view",
    components: {
        SelectCompanyPopup,
        ImageUploader
    },
    data() {
        return {
            resultPopup: false,
            saving: false,
            saveResultDto: {
                image: {
                    associateType: 'WorkOrderResult'
                },
            },
            isDelayEndStr: '否',
            companyPopup: false,
            downloadUrl: util.ApiUrl + '/file/download/',
            delayTimePopup: false,
            currentDate: '',
        }
    },
    computed: {
        workOrderInfo() {
            return this.$store.state.workOrder.workOrderInfo;
        }
    },
    methods: {
        onSaveResult() {
            this.saveResultDto.workOrderId = this.workOrderInfo.id;
            this.saving = true
            abp.ajax.post('/api/services/app/WorkOrder/MSaveWorkOrderResult', this.saveResultDto).then(res => {
                this.resultPopup = false;
                this.$emit('handleSuccess')
            }).finally(() => {
                this.saving = false;
            });
        },

        isDelayEndChange(val) {
            if (val === '是') {
                this.saveResultDto.isDelayEnd = true;
            } else {
                this.saveResultDto.isDelayEnd = false;
            }
        },

        companySelected(data) {
            this.saveResultDto.fieldValue = data.fieldValue
            this.saveResultDto.positionId = data.positionId
            this.saveResultDto.companyId = data.companyId
            this.companyPopup = false
        },

        onDelayTimeConfirm(val) {
            this.saveResultDto.delayTime = this.formatDate(val);
            this.delayTimePopup = false;
        },

        formatDate(date) {
            var m = date.getMonth() + 1;
            if (m < 10) {
                m = '0' + m;
            }
            var d = date.getDate();
            if (d < 10) {
                d = '0' + d;
            }
            return `${date.getFullYear()}-${m}-${d}`;
        },

        showResultPopup(data) {
            this.saveResultDto = data;
            this.resultPopup = true;
        }

    },
    created() {
        if (this.workOrderInfo.isDelayEnd) {
            this.isDelayEndStr = '是'
        } else {
            this.isDelayEndStr = '否'
        }
    }
}
